<template>
<div class="-search-sticky" data-scroll data-scroll-repeat>
    <div class="c-programmes-search u-bg-color-6 -search-margin-top">
        <div class="o-container">
            <div class="o-form">
                <div class="o-form__item__container">
                    <div class="o-form__item">
                        <label class="o-label sr-only" for="programmes-search">{{ t("Mots clés") }}</label>
                        <input @keyup="keyupSearch()" class="o-input" id="programmes-search" type="text"
                            :placeholder="t('Mots clés')" v-model="searchInput">
                        <svg class="o-ico -ico-search" role="img">
                            <title>search</title>
                            <use xlink:href="/assets/img/sprite.svg?v=2#search"></use>
                        </svg>
                    </div>
                    <div v-if="years.length > 0" class="o-form__item">
                        <label class="o-label sr-only" for="year">{{ t("Année") }}</label>
                        <select @change="changeSelectionYear()" class="o-select" id="year" v-model="selectedYear">
                            <option value="">{{ t("Année") }}</option>
                            <option v-for="year in years" :value="year">{{ year }}</option>
                        </select>
                        <svg class="o-ico -ico-arrow-down" role="img">
                            <title>arrow-down</title>
                            <use xlink:href="/assets/img/sprite.svg?v=2#arrow-down"></use>
                        </svg>
                    </div>
                    <!-- <div v-if="publics.length > 0" class="o-form__item">
                        <label class="o-label sr-only" for="theme">{{ t("Publics cibles") }}</label>
                        <select @change="changeSelectionPublic()" ref="theme" class="o-select" id="theme"
                            v-model="selectedPublic">
                            <option value="">{{ t("Publics cibles") }}</option>
                            <template v-for="category in publics">
                                <option v-if="category.parent === null" :value="category.id">{{ category.title }}
                                </option>
                                <template v-if="category.parent === null && hasChilds(category, publics)"
                                    v-for="child in publics">
                                    <option v-if="child.parent === category.id" :value="child.id">&mdash; {{ child.title
                                        }}</option>
                                    <template v-if="child.parent === category.id && hasChilds(child, publics)"
                                        v-for="children in publics">
                                        <option v-if="children.parent === child.id" :value="children.id">&mdash;&mdash;
                                            {{ children.title }}</option>
                                    </template>
                                </template>
                            </template>
                        </select>
                        <svg class="o-ico -ico-arrow-down" role="img">
                            <title>arrow-down</title>
                            <use xlink:href="/assets/img/sprite.svg?v=2#arrow-down"></use>
                        </svg>
                    </div>
                    <div v-if="types.length > 0" class="o-form__item">
                        <label class="o-label sr-only" for="theme">{{ t("Types") }}</label>
                        <select @change="changeSelectionType()" ref="theme" class="o-select" id="theme"
                            v-model="selectedType">
                            <option value="">{{ t("Types") }}</option>
                            <template v-for="category in types">
                                <option v-if="category.parent === null" :value="category.id">{{ category.title }}
                                </option>
                                <template v-if="category.parent === null && hasChilds(category, types)"
                                    v-for="child in types">
                                    <option v-if="child.parent === category.id" :value="child.id">&mdash; {{ child.title
                                        }}</option>
                                    <template v-if="child.parent === category.id && hasChilds(child, types)"
                                        v-for="children in types">
                                        <option v-if="children.parent === child.id" :value="children.id">&mdash;&mdash;
                                            {{ children.title }}</option>
                                    </template>
                                </template>
                            </template>
                        </select>
                        <svg class="o-ico -ico-arrow-down" role="img">
                            <title>arrow-down</title>
                            <use xlink:href="/assets/img/sprite.svg?v=2#arrow-down"></use>
                        </svg>
                    </div>
                    <div v-if="modes.length > 0" class="o-form__item">
                        <label class="o-label sr-only" for="theme">{{ t("Mode") }}</label>
                        <select @change="changeSelectionMode()" ref="theme" class="o-select" id="theme"
                            v-model="selectedMode">
                            <option value="">{{ t("Mode") }}</option>
                            <template v-for="category in modes">
                                <option :value="category.id">{{ t(category.title) }}
                                </option>
                            </template>
                        </select>
                        <svg class="o-ico -ico-arrow-down" role="img">
                            <title>arrow-down</title>
                            <use xlink:href="/assets/img/sprite.svg?v=2#arrow-down"></use>
                        </svg>
                    </div> -->
                    <div v-if="categories.length > 0" class="o-form__item">
                        <label class="o-label sr-only" for="theme">{{ t("Thématiques") }}</label>
                        <select @change="changeSelectionCategory()" ref="theme" class="o-select" id="theme" v-model="selectedCategory">
                            <option value="">{{ t("Thématiques") }}</option>
                            <template v-for="category in categories">
                                <option v-if="category.parent === null" :value="category.id">{{ category.title }}
                                </option>
                                <template v-if="category.parent === null && hasChilds(category, categories)" v-for="child in categories">
                                    <option v-if="child.parent === category.id" :value="child.id">&mdash; {{ child.title
                                    }}</option>
                                    <template v-if="child.parent === category.id && hasChilds(child, categories)"
                                        v-for="children in categories">
                                        <option v-if="children.parent === child.id" :value="children.id">&mdash;&mdash;
                                            {{ children.title }}</option>
                                    </template>
                                </template>
                            </template>
                        </select>
                        <svg class="o-ico -ico-arrow-down" role="img">
                            <title>arrow-down</title>
                            <use xlink:href="/assets/img/sprite.svg?v=2#arrow-down"></use>
                        </svg>
                    </div>
                    <div class="o-form__button c-tooltip__wrap">
                        <button class="o-button -button-bg js-advanced-search-button"
                            @click.prevent="toggleAdvancedSearch" aria-label="Ouvrir et/ou fermer la recherche">
                            <span class="o-button__icos">
                                <span class="o-button__ico">
                                    <svg class="o-ico -ico-search-category" role="img">
                                        <title>search-category</title>
                                        <use xlink:href="/assets/img/sprite.svg?v=2#search-category"></use>
                                    </svg>
                                </span>
                                <span class="o-button__ico">
                                    <svg class="o-ico -ico-search-category" role="img">
                                        <title>search-category</title>
                                        <use xlink:href="/assets/img/sprite.svg?v=2#search-category"></use>
                                    </svg>
                                </span>
                            </span>
                        </button>
                        <div class="c-tooltip">
                            <span class="c-tooltip__text">
                                {{ t("Voir les") }} <span class="js-events-results-count">0</span> {{ t("résultats") }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="c-programmes-search__filters">
    <div class="o-container">
        <div class="c-programmes-search__filters__wrap">
            <div class="c-programmes-search__filters__total">
                <span>
                    <span class="js-events-results-count">0</span> {{ t("résultats") }}
                </span>
            </div>
            <div class="c-programmes-search__filters__actives">
                <div v-for="tag in tags" class="c-programmes-search__filters__actives__item">
                    <button class="c-programmes-search__filters__remove" @click.prevent="removeTag(tag)">
                        <span></span>
                        <span></span>
                        <span class="sr-only">{{ t("Retirer le filtre") }} : {{ tag.title }}</span>
                    </button>
                    <span>
                        {{ tag.title }}
                    </span>
                </div>
            </div>
            <div class="c-programmes-search__filters__reset">
                <button class="o-button -button-reset" @click.prevent="resetSearch">
                    {{ t("Réinitialiser la recherche") }}
                </button>
            </div>
        </div>
    </div>
</div>
<div class="c-loader"></div>
</template>

<script>
import debounce from 'debounce';

export default {
    name: 'EvenementSearch',
    data() {
        return {
            searchInput: '',
            siteId: 1,
            years: [],
            categories: [],
            types: [],
            publics: [],
            modes: [],
            selectedYear: '',
            selectedCategory: '',
            selectedType: '',
            selectedPublic: '',
            selectedMode: '',
            selectedYears: [],
            selectedCategories: [],
            selectedTypes: [],
            selectedPublics: [],
            selectedModes: [],
            results: 0,
            controller: null,
            languageUrl: '/'
        }
    },
    mounted() {
        let lang = document.documentElement.lang;
        if (lang === 'fr-CA') {
            this.siteId = 1;
        } else {
            this.siteId = 2;
            this.languageUrl = '/en/';
        }

        //load query params
        const currentUrl = new URL(window.location.href);
        const query = currentUrl.search;
        const urlParams = new URLSearchParams(query);
        if (urlParams.has('years')) {
            this.selectedYears = urlParams.get('years').split(',');
        }
        if (urlParams.has('categories')) {
            let split = urlParams.get('categories').split(',');
            this.selectedCategories = split.map(Number);
        }
        if (urlParams.has('types')) {
            let split = urlParams.get('types').split(',');
            this.selectedTypes = split.map(Number);
        }
        if (urlParams.has('publics')) {
            let split = urlParams.get('publics').split(',');
            this.selectedPublics = split.map(Number);
        }
        if (urlParams.has('modes')) {
            let split = urlParams.get('modes').split(',');
            this.selectedModes = split.map(Number);
        }
        if (urlParams.has('s')) {
            this.searchInput = urlParams.get('s');
        }

        // let currentResults = document.querySelector('.js-articles-results');
        // this.results = currentResults.dataset.results;

        this.fetchAttributes();
    },
    computed: {
        tags() {
            let tags = [];
            if (this.selectedYears.length > 0) {
                let years = this.years.filter(year => this.selectedYears.includes(year));
                years.forEach(year => {
                    tags.push({
                        type: 'year',
                        id: year,
                        title: year
                    });
                });
            }
            if (this.selectedCategories.length > 0) {
                let categories = this.categories.filter(cat => this.selectedCategories.includes(cat.id));
                categories.forEach(category => {
                    tags.push({
                        type: 'category',
                        id: category.id,
                        title: category.title
                    });
                });
            }
            if (this.selectedTypes.length > 0) {
                let categories = this.types.filter(cat => this.selectedTypes.includes(cat.id));
                categories.forEach(category => {
                    tags.push({
                        type: 'type',
                        id: category.id,
                        title: category.title
                    });
                });
            }
            if (this.selectedPublics.length > 0) {
                let categories = this.publics.filter(cat => this.selectedPublics.includes(cat.id));
                categories.forEach(category => {
                    tags.push({
                        type: 'public',
                        id: category.id,
                        title: category.title
                    });
                });
            }
            if (this.selectedModes.length > 0) {
                let categories = this.modes.filter(cat => this.selectedModes.includes(cat.id));
                categories.forEach(category => {
                    tags.push({
                        type: 'mode',
                        id: category.id,
                        title: category.title
                    });
                });
            }
            return tags;
        }
    },
    methods: {
        t(string) {
            return EvenementLocalisation[string]
        },
        hasChilds(category, categories) {
            let hasChild = false
            this.categories.forEach(cat => {
                if (cat.parent === category.id) {
                    hasChild = true
                }
            })
            return hasChild
        },
        changeSelectionYear() {
            let current = this.selectedYear;
            if (current === '') return;
            if (!this.selectedYears.includes(current)) {
                this.selectedYears.push(current);
                this.refreshUrlQuery();
            }
            this.selectedYear = '';
        },
        changeSelectionCategory() {
            let current = this.selectedCategory;
            if (current === '') return;
            if (!this.selectedCategories.includes(current)) {
                this.selectedCategories.push(current);
                this.refreshUrlQuery();
            }
            this.selectedCategory = '';
        },
        changeSelectionType() {
            let current = this.selectedType;
            if (current === '') return;
            if (!this.selectedTypes.includes(current)) {
                this.selectedTypes.push(current);
                this.refreshUrlQuery();
            }
            this.selectedType = '';
        },
        changeSelectionPublic() {
            let current = this.selectedPublic;
            if (current === '') return;
            if (!this.selectedPublics.includes(current)) {
                this.selectedPublics.push(current);
                this.refreshUrlQuery();
            }
            this.selectedPublic = '';
        },
        changeSelectionMode() {
            let current = this.selectedMode;
            if (current === '') return;
            if (!this.selectedModes.includes(current)) {
                this.selectedModes.push(current);
                this.refreshUrlQuery();
            }
            this.selectedMode = '';
        },
        refreshUrlQuery() {
            // let query = '';
            // if (this.selectedYears.length > 0) {
            //     query += 'years=' + this.selectedYears.join(',') + '&';
            // }
            // if (this.selectedCategories.length > 0) {
            //     query += 'categories=' + this.selectedCategories.join(',') + '&';
            // }
            // if (this.searchInput) {
            //     query += 's=' + this.searchInput;
            // }
            // const currentUrl = new URL(window.location.href);
            // let pathName = currentUrl.pathname;
            // pathName = pathName.replace(/(p\d)/, '');
            // const newUrl = currentUrl.origin + pathName + '?' + query;
            // window.history.pushState({path:newUrl},'',newUrl);
            // console.log(('cats changed', this.selectedCategories))
            this.search();
        },
        fetchAttributes() {
            let formData = new FormData();
            formData.append('siteId', this.siteId);

            fetch(this.languageUrl + 'api/evenements/get-active-categories?siteId=' + this.siteId, {
                method: 'POST',
                body: formData,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Accept': 'application/json'
                }
            })
                .then(response => response.json())
                .then(data => {
                    if (data.years !== undefined) this.years = data.years;
                    if (data.categories !== undefined) this.categories = data.categories;
                    if (data.types !== undefined) this.types = data.types;
                    if (data.publics !== undefined) this.publics = data.publics;
                    if (data.modes !== undefined) this.modes = data.modes;
                })
        },
        // fetchAttributesOld() {
        //     fetch(this.languageUrl + 'api/search/evenement-index?siteId=' + this.siteId, {
        //         method: 'GET',
        //         headers: {
        //             'Accept': 'application/json'
        //         }
        //     })
        //     .then(response => response.json())
        //     .then(data => {
        //         if (data.years !== undefined) this.years = data.years;
        //         if (data.categories !== undefined) this.categories = data.categories;
        //     })
        // },
        resetSearch() {
            this.selectedYears = [];
            this.selectedCategories = [];
            this.selectedTypes = [];
            this.selectedPublics = [];
            this.selectedModes = [];
            this.searchInput = '';
            this.refreshUrlQuery();
        },
        removeTag(tag) {
            if (tag.type === 'year') {
                this.selectedYears = this.selectedYears.filter(year => year !== tag.id);
            }
            if (tag.type === 'category') {
                this.selectedCategories = this.selectedCategories.filter(category => category !== tag.id);
            }
            if (tag.type === 'type') {
                this.selectedTypes = this.selectedTypes.filter(type => type !== tag.id);
            }
            if (tag.type === 'public') {
                this.selectedPublics = this.selectedPublics.filter(publicItem => publicItem !== tag.id);
            }
            if (tag.type === 'mode') {
                this.selectedModes = this.selectedModes.filter(mode => mode !== tag.id);
            }
            this.refreshUrlQuery();
        },
        keyupSearch() {
            this.searchTyping();
        },
        searchTyping: debounce(function (e) {
            this.refreshUrlQuery();
        }, 500),
        search() {
            let targets = document.querySelectorAll('.js-events-module');
            var event = new CustomEvent("evenements:search", {
                detail: {
                    searchInput: this.searchInput,
                    selectedYears: this.selectedYears,
                    selectedCategories: this.selectedCategories,
                    selectedTypes: this.selectedTypes,
                    selectedPublics: this.selectedPublics,
                    selectedModes: this.selectedModes
                }
            });
            targets.forEach(target => {
                target.dispatchEvent(event);
            });

            // if (this.controller !== null) {
            //     try {
            //         this.controller.abort();
            //     } catch (error) {
            //         //console.log('ABORT', error)
            //     }
            // }
            // this.controller = new AbortController();
            // document.body.classList.add('blog-loading');

            // let url = window.location.href
            // url = url.replace(/(p\d)/, '');
            // try {
            //     fetch(url, {
            //         method: 'GET',
            //         signal: this.controller.signal,
            //     })
            //     .then(response => response.text())
            //     .then(data => {
            //         let parser = new DOMParser();
            //         let doc = parser.parseFromString(data, 'text/html');
            //         let results = doc.querySelector('.js-articles-results');
            //         let currentResults = document.querySelector('.js-articles-results');
            //         let featured = doc.querySelector('.js-articles-featured');
            //         let currentFeatured = document.querySelector('.js-articles-featured');
            //         if (featured) {
            //             if (!currentFeatured) {
            //                 currentResults.insertAdjacentElement('beforebegin', featured);
            //             } else {
            //                 currentFeatured.innerHTML = featured.innerHTML;
            //             }
            //         } else {
            //             if (currentFeatured) {
            //                 currentFeatured.remove();
            //             }
            //         }
            //         currentResults.innerHTML = results.innerHTML;
            //         let pager = doc.querySelector('.c-pager');
            //         let currentPager = document.querySelector('.c-pager');
            //         if (pager) {
            //             if (!currentPager) {
            //                 currentResults.querySelector('.o-grid').insertAdjacentElement('afterend', pager);
            //             } else {
            //                 currentPager.innerHTML = pager.innerHTML;
            //             }
            //         } else {
            //             if (currentPager) {
            //                 currentPager.remove();
            //             }
            //         }
            //         this.results = results.dataset.results;

            //         let title = document.querySelectorAll('.js-title-blog');
            //         let noresult = document.querySelectorAll('.no-result-message');
            //         if (this.results == '0') {
            //             //console.log('HIDE', title)
            //             title.forEach(element => {
            //                 element.classList.add('hidden');
            //             });
            //             noresult.forEach(element => {
            //                 element.classList.remove('hidden');
            //             });
            //         } else {
            //             //console.log('SHOW')
            //             title.forEach(element => {
            //                 element.classList.remove('hidden');
            //             });
            //             noresult.forEach(element => {
            //                 element.classList.add('hidden');
            //             });
            //         }

            //         this.controller = null;
            //         document.body.classList.remove('blog-loading');
            //     })
            //     .catch(error => {
            //         //console.log('ERROR', error)
            //         document.body.classList.remove('blog-loading');
            //     });
            // } catch (error) {
            //     //console.log('ERROR', error)
            //     document.body.classList.remove('blog-loading');
            // }
        }
    }
}
</script>